var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("下载页。。。")]),_c('a',{attrs:{"id":"down_file"}})])
}]

export { render, staticRenderFns }